import { fetchUWLocationResearchResults } from '../../../../../services/uwsearch';
import React, { useEffect, useState } from 'react';
import { Link, Tooltip, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import InfiniteScroll from 'react-infinite-scroll-component';

interface ResearchSearchResultProps {
    locationName: string | undefined;
    locationAddress: string | undefined;
    researchTerm?: string | undefined;
    researchSite?: string;
    isOpen: boolean;
}

const ResearchSearchResult: React.FunctionComponent<ResearchSearchResultProps> = (props) => {
    const { locationName, locationAddress, researchTerm, researchSite, isOpen } = props;

    const [results, setResults] = useState<any[]>([]);
    const [hasMoreResults, setHasMoreResults] = useState<boolean>(true);

    const fetchResearchResults = async () => {
        if (isOpen && locationName) {
            const res = await fetchUWLocationResearchResults(
                locationName,
                locationAddress,
                researchTerm,
                researchSite,
                10,
                results.length + 1
            );
            const newResults = results.concat(res);
            if (newResults.length < 100 && res.length === 10) {
                setHasMoreResults(true);
            } else {
                setHasMoreResults(false);
            }
            setResults(newResults);
        } else {
            setResults([]);
        }
    };

    const linktooltip = (result: any) => <div dangerouslySetInnerHTML={{ __html: result.snippet }} />;

    useEffect(() => {
        fetchResearchResults();
    }, [isOpen]);

    const endMessage =
        results.length > 0 ? (
            <Typography variant={'caption'}>No Further Results Available</Typography>
        ) : (
            <Typography variant={'caption'}>No Results Available</Typography>
        );

    return (
        <Grid container direction="column" justifyContent="center" alignItems="stretch" spacing={1}>
            <InfiniteScroll
                height={300}
                next={fetchResearchResults}
                hasMore={hasMoreResults}
                loader={<h4>Loading...</h4>}
                dataLength={results.length}
                endMessage={endMessage}
            >
                {results.map((result, idx) => (
                    <Grid key={result.cacheId || `searchresult${idx}`} xs={12}>
                        <Tooltip title={linktooltip(result)} arrow placement={'top-start'}>
                            <Link href={result.link} target="_blank" underline="hover">
                                <Typography dangerouslySetInnerHTML={{ __html: result.htmlTitle }}></Typography>
                            </Link>
                        </Tooltip>
                    </Grid>
                ))}
            </InfiniteScroll>
        </Grid>
    );
};

export default ResearchSearchResult;
